import * as i0 from '@angular/core';
import { InjectionToken, Directive, Injector, Input, EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Optional, Inject, ContentChild, Output, ViewChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
const _c0 = ["gutterEls"];
const _c1 = ["*"];
const _c2 = (a0, a1, a2, a3, a4, a5) => ({
  areaBefore: a0,
  areaAfter: a1,
  gutterNum: a2,
  first: a3,
  last: a4,
  isDragged: a5
});
function SplitComponent_ng_template_1_div_0_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SplitComponent_ng_template_1_div_0_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SplitComponent_ng_template_1_div_0_ng_container_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const injector_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    const area_r6 = ctx_r4.$implicit;
    const index_r2 = ctx_r4.index;
    const first_r7 = ctx_r4.first;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.customGutter.template)("ngTemplateOutletContext", i0.ɵɵpureFunction6(3, _c2, area_r6, ctx_r2.displayedAreas[index_r2 + 1], index_r2 + 1, first_r7, index_r2 === ctx_r2.displayedAreas.length - 2, ctx_r2.draggedGutterNum === index_r2 + 1))("ngTemplateOutletInjector", injector_r4);
  }
}
function SplitComponent_ng_template_1_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SplitComponent_ng_template_1_div_0_ng_container_2_ng_container_1_Template, 2, 10, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const index_r2 = i0.ɵɵnextContext(2).index;
    i0.ɵɵadvance();
    i0.ɵɵproperty("asSplitGutterDynamicInjector", index_r2 + 1);
  }
}
function SplitComponent_ng_template_1_div_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
  }
}
function SplitComponent_ng_template_1_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4, 0);
    i0.ɵɵlistener("keydown", function SplitComponent_ng_template_1_div_0_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const index_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startKeyboardDrag($event, index_r2 * 2 + 1, index_r2 + 1));
    })("mousedown", function SplitComponent_ng_template_1_div_0_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const index_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startMouseDrag($event, index_r2 * 2 + 1, index_r2 + 1));
    })("touchstart", function SplitComponent_ng_template_1_div_0_Template_div_touchstart_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const index_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startMouseDrag($event, index_r2 * 2 + 1, index_r2 + 1));
    })("mouseup", function SplitComponent_ng_template_1_div_0_Template_div_mouseup_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const index_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clickGutter($event, index_r2 + 1));
    })("touchend", function SplitComponent_ng_template_1_div_0_Template_div_touchend_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const index_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clickGutter($event, index_r2 + 1));
    });
    i0.ɵɵtemplate(2, SplitComponent_ng_template_1_div_0_ng_container_2_Template, 2, 1, "ng-container", 5)(3, SplitComponent_ng_template_1_div_0_ng_template_3_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const defaultGutterTpl_r8 = i0.ɵɵreference(4);
    const ctx_r4 = i0.ɵɵnextContext();
    const area_r6 = ctx_r4.$implicit;
    const index_r2 = ctx_r4.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("flex-basis", ctx_r2.gutterSize, "px")("order", index_r2 * 2 + 1);
    i0.ɵɵclassProp("as-dragged", ctx_r2.draggedGutterNum === index_r2 + 1);
    i0.ɵɵattribute("aria-label", ctx_r2.gutterAriaLabel)("aria-orientation", ctx_r2.direction)("aria-valuemin", area_r6.minSize)("aria-valuemax", area_r6.maxSize)("aria-valuenow", area_r6.size === "*" ? null : area_r6.size)("aria-valuetext", ctx_r2.getAriaAreaSizeText(area_r6.size));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.customGutter == null ? null : ctx_r2.customGutter.template)("ngIfElse", defaultGutterTpl_r8);
  }
}
function SplitComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SplitComponent_ng_template_1_div_0_Template, 5, 14, "div", 3);
  }
  if (rf & 2) {
    const last_r9 = ctx.last;
    i0.ɵɵproperty("ngIf", last_r9 === false);
  }
}
function getPointFromEvent(event) {
  // TouchEvent
  if (event.changedTouches !== undefined && event.changedTouches.length > 0) {
    return {
      x: event.changedTouches[0].clientX,
      y: event.changedTouches[0].clientY
    };
  }
  // MouseEvent
  else if (event.clientX !== undefined && event.clientY !== undefined) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  // KeyboardEvent
  else if (event.currentTarget !== undefined) {
    const gutterEl = event.currentTarget;
    return {
      x: gutterEl.offsetLeft,
      y: gutterEl.offsetTop
    };
  }
  return null;
}
function pointDeltaEquals(lhs, rhs, deltaPx) {
  return Math.abs(lhs.x - rhs.x) <= deltaPx && Math.abs(lhs.y - rhs.y) <= deltaPx;
}
function getKeyboardEndpoint(event, direction) {
  // Return null if direction keys on the opposite axis were pressed
  if (direction === 'horizontal') {
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowRight':
      case 'PageUp':
      case 'PageDown':
        break;
      default:
        return null;
    }
  }
  if (direction === 'vertical') {
    switch (event.key) {
      case 'ArrowUp':
      case 'ArrowDown':
      case 'PageUp':
      case 'PageDown':
        break;
      default:
        return null;
    }
  }
  const gutterEl = event.currentTarget;
  const offset = event.key === 'PageUp' || event.key === 'PageDown' ? 50 * 10 : 50;
  let offsetX = gutterEl.offsetLeft,
    offsetY = gutterEl.offsetTop;
  switch (event.key) {
    case 'ArrowLeft':
      offsetX -= offset;
      break;
    case 'ArrowRight':
      offsetX += offset;
      break;
    case 'ArrowUp':
      offsetY -= offset;
      break;
    case 'ArrowDown':
      offsetY += offset;
      break;
    case 'PageUp':
      if (direction === 'vertical') {
        offsetY -= offset;
      } else {
        offsetX += offset;
      }
      break;
    case 'PageDown':
      if (direction === 'vertical') {
        offsetY += offset;
      } else {
        offsetX -= offset;
      }
      break;
    default:
      return null;
  }
  return {
    x: offsetX,
    y: offsetY
  };
}
function getElementPixelSize(elRef, direction) {
  const rect = elRef.nativeElement.getBoundingClientRect();
  return direction === 'horizontal' ? rect.width : rect.height;
}
function getInputBoolean(v) {
  return typeof v === 'boolean' ? v : v !== 'false';
}
function getInputPositiveNumber(v, defaultValue) {
  if (v === null || v === undefined) return defaultValue;
  v = Number(v);
  return !isNaN(v) && v >= 0 ? v : defaultValue;
}
function isUserSizesValid(unit, sizes) {
  // All sizes total must be 100 unless there are wildcards.
  // While having wildcards all other sizes sum should be less than 100.
  // There should be maximum one wildcard.
  if (unit === 'percent') {
    const total = sizes.reduce((total, s) => s !== '*' ? total + s : total, 0);
    const wildcardSizeAreas = sizes.filter(size => size === '*');
    if (wildcardSizeAreas.length > 1) {
      return false;
    }
    if (wildcardSizeAreas.length === 1) {
      return total < 100.1;
    }
    return total > 99.9 && total < 100.1;
  }
  // A size at null is mandatory but only one.
  if (unit === 'pixel') {
    return sizes.filter(s => s === '*').length === 1;
  }
}
function getAreaMinSize(a) {
  if (a.size === '*') {
    return null;
  }
  if (a.component.lockSize === true) {
    return a.size;
  }
  if (a.component.minSize === null) {
    return null;
  }
  return a.component.minSize;
}
function getAreaMaxSize(a) {
  if (a.size === '*') {
    return null;
  }
  if (a.component.lockSize === true) {
    return a.size;
  }
  if (a.component.maxSize === null) {
    return null;
  }
  if (a.component.maxSize < a.size) {
    return a.size;
  }
  return a.component.maxSize;
}
function getGutterSideAbsorptionCapacity(unit, sideAreas, pixels, allAreasSizePixel) {
  return sideAreas.reduce((acc, area) => {
    const res = getAreaAbsorptionCapacity(unit, area, acc.remain, allAreasSizePixel);
    acc.list.push(res);
    acc.remain = res.pixelRemain;
    return acc;
  }, {
    remain: pixels,
    list: []
  });
}
function getAreaAbsorptionCapacity(unit, areaSnapshot, pixels, allAreasSizePixel) {
  // No pain no gain
  if (pixels === 0) {
    return {
      areaSnapshot,
      pixelAbsorb: 0,
      percentAfterAbsorption: areaSnapshot.sizePercentAtStart,
      pixelRemain: 0
    };
  }
  // Area start at zero and need to be reduced, not possible
  if (areaSnapshot.sizePixelAtStart === 0 && pixels < 0) {
    return {
      areaSnapshot,
      pixelAbsorb: 0,
      percentAfterAbsorption: 0,
      pixelRemain: pixels
    };
  }
  if (unit === 'percent') {
    return getAreaAbsorptionCapacityPercent(areaSnapshot, pixels, allAreasSizePixel);
  }
  if (unit === 'pixel') {
    return getAreaAbsorptionCapacityPixel(areaSnapshot, pixels);
  }
}
function getAreaAbsorptionCapacityPercent(areaSnapshot, pixels, allAreasSizePixel) {
  const tempPixelSize = areaSnapshot.sizePixelAtStart + pixels;
  const tempPercentSize = tempPixelSize / allAreasSizePixel * 100;
  // ENLARGE AREA
  if (pixels > 0) {
    // If maxSize & newSize bigger than it > absorb to max and return remaining pixels
    if (areaSnapshot.area.maxSize !== null && tempPercentSize > areaSnapshot.area.maxSize) {
      // Use area.area.maxSize as newPercentSize and return calculate pixels remaining
      const maxSizePixel = areaSnapshot.area.maxSize / 100 * allAreasSizePixel;
      return {
        areaSnapshot,
        pixelAbsorb: maxSizePixel,
        percentAfterAbsorption: areaSnapshot.area.maxSize,
        pixelRemain: areaSnapshot.sizePixelAtStart + pixels - maxSizePixel
      };
    }
    return {
      areaSnapshot,
      pixelAbsorb: pixels,
      percentAfterAbsorption: tempPercentSize > 100 ? 100 : tempPercentSize,
      pixelRemain: 0
    };
  }
  // REDUCE AREA
  else if (pixels < 0) {
    // If minSize & newSize smaller than it > absorb to min and return remaining pixels
    if (areaSnapshot.area.minSize !== null && tempPercentSize < areaSnapshot.area.minSize) {
      // Use area.area.minSize as newPercentSize and return calculate pixels remaining
      const minSizePixel = areaSnapshot.area.minSize / 100 * allAreasSizePixel;
      return {
        areaSnapshot,
        pixelAbsorb: minSizePixel,
        percentAfterAbsorption: areaSnapshot.area.minSize,
        pixelRemain: areaSnapshot.sizePixelAtStart + pixels - minSizePixel
      };
    }
    // If reduced under zero > return remaining pixels
    else if (tempPercentSize < 0) {
      // Use 0 as newPercentSize and return calculate pixels remaining
      return {
        areaSnapshot,
        pixelAbsorb: -areaSnapshot.sizePixelAtStart,
        percentAfterAbsorption: 0,
        pixelRemain: pixels + areaSnapshot.sizePixelAtStart
      };
    }
    return {
      areaSnapshot,
      pixelAbsorb: pixels,
      percentAfterAbsorption: tempPercentSize,
      pixelRemain: 0
    };
  }
}
function getAreaAbsorptionCapacityPixel(areaSnapshot, pixels) {
  const tempPixelSize = areaSnapshot.sizePixelAtStart + pixels;
  // ENLARGE AREA
  if (pixels > 0) {
    // If maxSize & newSize bigger than it > absorb to max and return remaining pixels
    if (areaSnapshot.area.maxSize !== null && tempPixelSize > areaSnapshot.area.maxSize) {
      return {
        areaSnapshot,
        pixelAbsorb: areaSnapshot.area.maxSize - areaSnapshot.sizePixelAtStart,
        percentAfterAbsorption: -1,
        pixelRemain: tempPixelSize - areaSnapshot.area.maxSize
      };
    }
    return {
      areaSnapshot,
      pixelAbsorb: pixels,
      percentAfterAbsorption: -1,
      pixelRemain: 0
    };
  }
  // REDUCE AREA
  else if (pixels < 0) {
    // If minSize & newSize smaller than it > absorb to min and return remaining pixels
    if (areaSnapshot.area.minSize !== null && tempPixelSize < areaSnapshot.area.minSize) {
      return {
        areaSnapshot,
        pixelAbsorb: areaSnapshot.area.minSize + pixels - tempPixelSize,
        percentAfterAbsorption: -1,
        pixelRemain: tempPixelSize - areaSnapshot.area.minSize
      };
    }
    // If reduced under zero > return remaining pixels
    else if (tempPixelSize < 0) {
      return {
        areaSnapshot,
        pixelAbsorb: -areaSnapshot.sizePixelAtStart,
        percentAfterAbsorption: -1,
        pixelRemain: pixels + areaSnapshot.sizePixelAtStart
      };
    }
    return {
      areaSnapshot,
      pixelAbsorb: pixels,
      percentAfterAbsorption: -1,
      pixelRemain: 0
    };
  }
}
function updateAreaSize(unit, item) {
  // Update size except for the wildcard size area
  if (item.areaSnapshot.area.size !== '*') {
    if (unit === 'percent') {
      item.areaSnapshot.area.size = item.percentAfterAbsorption;
    } else if (unit === 'pixel') {
      item.areaSnapshot.area.size = item.areaSnapshot.sizePixelAtStart + item.pixelAbsorb;
    }
  }
}
const ANGULAR_SPLIT_DEFAULT_OPTIONS = new InjectionToken('angular-split-global-config');
let SplitGutterDirective = /*#__PURE__*/(() => {
  class SplitGutterDirective {
    constructor(template) {
      this.template = template;
      /**
       * The map holds reference to the drag handle elements inside instances
       * of the provided template.
       */
      this.gutterToHandleElementMap = new Map();
      /**
       * The map holds reference to the excluded drag elements inside instances
       * of the provided template.
       */
      this.gutterToExcludeDragElementMap = new Map();
    }
    canStartDragging(originElement, gutterNum) {
      if (this.gutterToExcludeDragElementMap.has(gutterNum)) {
        const isInsideExclude = this.gutterToExcludeDragElementMap.get(gutterNum).some(gutterExcludeElement => gutterExcludeElement.nativeElement.contains(originElement));
        if (isInsideExclude) {
          return false;
        }
      }
      if (this.gutterToHandleElementMap.has(gutterNum)) {
        return this.gutterToHandleElementMap.get(gutterNum).some(gutterHandleElement => gutterHandleElement.nativeElement.contains(originElement));
      }
      return true;
    }
    addToMap(map, gutterNum, elementRef) {
      if (map.has(gutterNum)) {
        map.get(gutterNum).push(elementRef);
      } else {
        map.set(gutterNum, [elementRef]);
      }
    }
    removedFromMap(map, gutterNum, elementRef) {
      const elements = map.get(gutterNum);
      elements.splice(elements.indexOf(elementRef), 1);
      if (elements.length === 0) {
        map.delete(gutterNum);
      }
    }
    static ngTemplateContextGuard(dir, ctx) {
      return true;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function SplitGutterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitGutterDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SplitGutterDirective,
        selectors: [["", "asSplitGutter", ""]]
      });
    }
  }
  return SplitGutterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Identifies the gutter by number through DI
 * to allow SplitGutterDragHandleDirective and SplitGutterExcludeFromDragDirective to know
 * the gutter template context without inputs
 */
const GUTTER_NUM_TOKEN = new InjectionToken('Gutter num');

/**
 * This directive allows creating a dynamic injector inside ngFor
 * with dynamic gutter num and expose the injector for ngTemplateOutlet usage
 */
let SplitGutterDynamicInjectorDirective = /*#__PURE__*/(() => {
  class SplitGutterDynamicInjectorDirective {
    set gutterNum(value) {
      this.vcr.clear();
      const injector = Injector.create({
        providers: [{
          provide: GUTTER_NUM_TOKEN,
          useValue: value
        }],
        parent: this.vcr.injector
      });
      this.vcr.createEmbeddedView(this.templateRef, {
        $implicit: injector
      });
    }
    constructor(vcr, templateRef) {
      this.vcr = vcr;
      this.templateRef = templateRef;
    }
    static ngTemplateContextGuard(dir, ctx) {
      return true;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function SplitGutterDynamicInjectorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitGutterDynamicInjectorDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SplitGutterDynamicInjectorDirective,
        selectors: [["", "asSplitGutterDynamicInjector", ""]],
        inputs: {
          gutterNum: [0, "asSplitGutterDynamicInjector", "gutterNum"]
        }
      });
    }
  }
  return SplitGutterDynamicInjectorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * angular-split
 *
 *
 *  PERCENT MODE ([unit]="'percent'")
 *  ___________________________________________________________________________________________
 * |       A       [g1]       B       [g2]       C       [g3]       D       [g4]       E       |
 * |-------------------------------------------------------------------------------------------|
 * |       20                 30                 20                 15                 15      | <-- [size]="x"
 * |               10px               10px               10px               10px               | <-- [gutterSize]="10"
 * |calc(20% - 8px)    calc(30% - 12px)   calc(20% - 8px)    calc(15% - 6px)    calc(15% - 6px)| <-- CSS flex-basis property (with flex-grow&shrink at 0)
 * |     152px              228px              152px              114px              114px     | <-- el.getBoundingClientRect().width
 * |___________________________________________________________________________________________|
 *                                                                                 800px         <-- el.getBoundingClientRect().width
 *  flex-basis = calc( { area.size }% - { area.size/100 * nbGutter*gutterSize }px );
 *
 *
 *  PIXEL MODE ([unit]="'pixel'")
 *  ___________________________________________________________________________________________
 * |       A       [g1]       B       [g2]       C       [g3]       D       [g4]       E       |
 * |-------------------------------------------------------------------------------------------|
 * |      100                250                 *                 150                100      | <-- [size]="y"
 * |               10px               10px               10px               10px               | <-- [gutterSize]="10"
 * |   0 0 100px          0 0 250px           1 1 auto          0 0 150px          0 0 100px   | <-- CSS flex property (flex-grow/flex-shrink/flex-basis)
 * |     100px              250px              200px              150px              100px     | <-- el.getBoundingClientRect().width
 * |___________________________________________________________________________________________|
 *                                                                                 800px         <-- el.getBoundingClientRect().width
 *
 */
let SplitComponent = /*#__PURE__*/(() => {
  class SplitComponent {
    set direction(v) {
      this._direction = v === 'vertical' ? 'vertical' : 'horizontal';
      this.renderer.addClass(this.elRef.nativeElement, `as-${this._direction}`);
      this.renderer.removeClass(this.elRef.nativeElement, `as-${this._direction === 'vertical' ? 'horizontal' : 'vertical'}`);
      this.build(false, false);
    }
    get direction() {
      return this._direction;
    }
    set unit(v) {
      this._unit = v === 'pixel' ? 'pixel' : 'percent';
      this.renderer.addClass(this.elRef.nativeElement, `as-${this._unit}`);
      this.renderer.removeClass(this.elRef.nativeElement, `as-${this._unit === 'pixel' ? 'percent' : 'pixel'}`);
      this.build(false, true);
    }
    get unit() {
      return this._unit;
    }
    set gutterSize(v) {
      this._gutterSize = getInputPositiveNumber(v, 11);
      this.build(false, false);
    }
    get gutterSize() {
      return this._gutterSize;
    }
    set gutterStep(v) {
      this._gutterStep = getInputPositiveNumber(v, 1);
    }
    get gutterStep() {
      return this._gutterStep;
    }
    set restrictMove(v) {
      this._restrictMove = getInputBoolean(v);
    }
    get restrictMove() {
      return this._restrictMove;
    }
    set useTransition(v) {
      this._useTransition = getInputBoolean(v);
      if (this._useTransition) {
        this.renderer.addClass(this.elRef.nativeElement, 'as-transition');
      } else {
        this.renderer.removeClass(this.elRef.nativeElement, 'as-transition');
      }
    }
    get useTransition() {
      return this._useTransition;
    }
    set disabled(v) {
      this._disabled = getInputBoolean(v);
      if (this._disabled) {
        this.renderer.addClass(this.elRef.nativeElement, 'as-disabled');
      } else {
        this.renderer.removeClass(this.elRef.nativeElement, 'as-disabled');
      }
    }
    get disabled() {
      return this._disabled;
    }
    set dir(v) {
      this._dir = v === 'rtl' ? 'rtl' : 'ltr';
      this.renderer.setAttribute(this.elRef.nativeElement, 'dir', this._dir);
    }
    get dir() {
      return this._dir;
    }
    set gutterDblClickDuration(v) {
      this._gutterDblClickDuration = getInputPositiveNumber(v, 0);
    }
    get gutterDblClickDuration() {
      return this._gutterDblClickDuration;
    }
    get transitionEnd() {
      return new Observable(subscriber => this.transitionEndSubscriber = subscriber).pipe(debounceTime(20));
    }
    constructor(ngZone, elRef, cdRef, renderer, globalConfig) {
      this.ngZone = ngZone;
      this.elRef = elRef;
      this.cdRef = cdRef;
      this.renderer = renderer;
      this.gutterClickDeltaPx = 2;
      this._config = {
        direction: 'horizontal',
        unit: 'percent',
        gutterSize: 11,
        gutterStep: 1,
        restrictMove: false,
        useTransition: false,
        disabled: false,
        dir: 'ltr',
        gutterDblClickDuration: 0
      };
      this.dragStart = new EventEmitter(false);
      this.dragEnd = new EventEmitter(false);
      this.gutterClick = new EventEmitter(false);
      this.gutterDblClick = new EventEmitter(false);
      this.dragProgressSubject = new Subject();
      this.dragProgress$ = this.dragProgressSubject.asObservable();
      this.isDragging = false;
      this.isWaitingClear = false;
      this.isWaitingInitialMove = false;
      this.dragListeners = [];
      this.snapshot = null;
      this.startPoint = null;
      this.endPoint = null;
      this.displayedAreas = [];
      this.hiddenAreas = [];
      this._clickTimeout = null;
      this.draggedGutterNum = undefined;
      // To force adding default class, could be override by user @Input() or not
      this.direction = this._direction;
      this._config = globalConfig ? Object.assign(this._config, globalConfig) : this._config;
      Object.keys(this._config).forEach(property => {
        this[property] = this._config[property];
      });
    }
    ngAfterViewInit() {
      this.ngZone.runOutsideAngular(() => {
        // To avoid transition at first rendering
        setTimeout(() => this.renderer.addClass(this.elRef.nativeElement, 'as-init'));
      });
    }
    getNbGutters() {
      return this.displayedAreas.length === 0 ? 0 : this.displayedAreas.length - 1;
    }
    addArea(component) {
      const newArea = {
        component,
        order: 0,
        size: 0,
        minSize: null,
        maxSize: null,
        sizeBeforeCollapse: null,
        gutterBeforeCollapse: 0
      };
      if (component.visible === true) {
        this.displayedAreas.push(newArea);
        this.build(true, true);
      } else {
        this.hiddenAreas.push(newArea);
      }
    }
    removeArea(component) {
      if (this.displayedAreas.some(a => a.component === component)) {
        const area = this.displayedAreas.find(a => a.component === component);
        this.displayedAreas.splice(this.displayedAreas.indexOf(area), 1);
        this.build(true, true);
      } else if (this.hiddenAreas.some(a => a.component === component)) {
        const area = this.hiddenAreas.find(a => a.component === component);
        this.hiddenAreas.splice(this.hiddenAreas.indexOf(area), 1);
      }
    }
    updateArea(component, resetOrders, resetSizes) {
      if (component.visible === true) {
        this.build(resetOrders, resetSizes);
      }
    }
    showArea(component) {
      const area = this.hiddenAreas.find(a => a.component === component);
      if (area === undefined) {
        return;
      }
      const areas = this.hiddenAreas.splice(this.hiddenAreas.indexOf(area), 1);
      this.displayedAreas.push(...areas);
      this.build(true, true);
    }
    hideArea(comp) {
      const area = this.displayedAreas.find(a => a.component === comp);
      if (area === undefined) {
        return;
      }
      const areas = this.displayedAreas.splice(this.displayedAreas.indexOf(area), 1);
      areas.forEach(item => {
        item.order = 0;
        item.size = 0;
      });
      this.hiddenAreas.push(...areas);
      this.build(true, true);
    }
    getVisibleAreaSizes() {
      return this.displayedAreas.map(a => a.size);
    }
    setVisibleAreaSizes(sizes) {
      if (sizes.length !== this.displayedAreas.length) {
        return false;
      }
      const formattedSizes = sizes.map(s => getInputPositiveNumber(s, '*'));
      const isValid = isUserSizesValid(this.unit, formattedSizes);
      if (isValid === false) {
        return false;
      }
      // @@ts-expect-error
      this.displayedAreas.forEach((area, i) => area.component.size = formattedSizes[i]);
      this.build(false, true);
      return true;
    }
    build(resetOrders, resetSizes) {
      this.stopDragging();
      // ¤ AREAS ORDER
      if (resetOrders === true) {
        // If user provided 'order' for each area, use it to sort them.
        if (this.displayedAreas.every(a => a.component.order !== null)) {
          this.displayedAreas.sort((a, b) => a.component.order - b.component.order);
        }
        // Then set real order with multiples of 2, numbers between will be used by gutters.
        this.displayedAreas.forEach((area, i) => {
          area.order = i * 2;
          area.component.setStyleOrder(area.order);
        });
      }
      // ¤ AREAS SIZE
      if (resetSizes === true) {
        const useUserSizes = isUserSizesValid(this.unit, this.displayedAreas.map(a => a.component.size));
        switch (this.unit) {
          case 'percent':
            {
              const defaultSize = 100 / this.displayedAreas.length;
              this.displayedAreas.forEach(area => {
                area.size = useUserSizes ? area.component.size : defaultSize;
                area.minSize = getAreaMinSize(area);
                area.maxSize = getAreaMaxSize(area);
              });
              break;
            }
          case 'pixel':
            {
              if (useUserSizes) {
                this.displayedAreas.forEach(area => {
                  area.size = area.component.size;
                  area.minSize = getAreaMinSize(area);
                  area.maxSize = getAreaMaxSize(area);
                });
              } else {
                const wildcardSizeAreas = this.displayedAreas.filter(a => a.component.size === '*');
                // No wildcard area > Need to select one arbitrarily > first
                if (wildcardSizeAreas.length === 0 && this.displayedAreas.length > 0) {
                  this.displayedAreas.forEach((area, i) => {
                    area.size = i === 0 ? '*' : area.component.size;
                    area.minSize = i === 0 ? area.component.minSize : getAreaMinSize(area);
                    area.maxSize = i === 0 ? null : getAreaMaxSize(area);
                  });
                } else if (wildcardSizeAreas.length > 1) {
                  // More than one wildcard area > Need to keep only one arbitrarily > first
                  let alreadyGotOne = false;
                  this.displayedAreas.forEach(area => {
                    if (area.component.size === '*') {
                      if (alreadyGotOne === false) {
                        area.size = '*';
                        area.minSize = null;
                        area.maxSize = null;
                        alreadyGotOne = true;
                      } else {
                        area.size = 100;
                        area.minSize = null;
                        area.maxSize = null;
                      }
                    } else {
                      area.size = area.component.size;
                      area.minSize = getAreaMinSize(area);
                      area.maxSize = getAreaMaxSize(area);
                    }
                  });
                }
              }
              break;
            }
        }
      }
      this.refreshStyleSizes();
      this.cdRef.markForCheck();
    }
    refreshStyleSizes() {
      ///////////////////////////////////////////
      // PERCENT MODE
      if (this.unit === 'percent') {
        // Only one area > flex-basis 100%
        if (this.displayedAreas.length === 1) {
          this.displayedAreas[0].component.setStyleFlex(0, 0, `100%`, false, false);
        } else {
          // Multiple areas > use each percent basis
          const sumGutterSize = this.getNbGutters() * this.gutterSize;
          this.displayedAreas.forEach(area => {
            // Area with wildcard size
            if (area.size === '*') {
              if (this.displayedAreas.length === 1) {
                area.component.setStyleFlex(1, 1, `100%`, false, false);
              } else {
                area.component.setStyleFlex(1, 1, `auto`, false, false);
              }
            } else {
              area.component.setStyleFlex(0, 0, `calc( ${area.size}% - ${area.size / 100 * sumGutterSize}px )`, area.minSize !== null && area.minSize === area.size, area.maxSize !== null && area.maxSize === area.size);
            }
          });
        }
      } else if (this.unit === 'pixel') {
        ///////////////////////////////////////////
        // PIXEL MODE
        this.displayedAreas.forEach(area => {
          // Area with wildcard size
          if (area.size === '*') {
            if (this.displayedAreas.length === 1) {
              area.component.setStyleFlex(1, 1, `100%`, false, false);
            } else {
              area.component.setStyleFlex(1, 1, `auto`, false, false);
            }
          } else {
            // Area with pixel size
            // Only one area > flex-basis 100%
            if (this.displayedAreas.length === 1) {
              area.component.setStyleFlex(0, 0, `100%`, false, false);
            } else {
              // Multiple areas > use each pixel basis
              area.component.setStyleFlex(0, 0, `${area.size}px`, area.minSize !== null && area.minSize === area.size, area.maxSize !== null && area.maxSize === area.size);
            }
          }
        });
      }
    }
    clickGutter(event, gutterNum) {
      const tempPoint = getPointFromEvent(event);
      // Be sure mouseup/touchend happened if touch/cursor is not moved.
      if (this.startPoint && pointDeltaEquals(this.startPoint, tempPoint, this.gutterClickDeltaPx) && (!this.isDragging || this.isWaitingInitialMove)) {
        // If timeout in progress and new click > clearTimeout & dblClickEvent
        if (this._clickTimeout !== null) {
          window.clearTimeout(this._clickTimeout);
          this._clickTimeout = null;
          this.notify('dblclick', gutterNum);
          this.stopDragging();
        } else {
          // Else start timeout to call clickEvent at end
          this._clickTimeout = window.setTimeout(() => {
            this._clickTimeout = null;
            this.notify('click', gutterNum);
            this.stopDragging();
          }, this.gutterDblClickDuration);
        }
      }
    }
    startKeyboardDrag(event, gutterOrder, gutterNum) {
      if (this.disabled === true || this.isWaitingClear === true) {
        return;
      }
      const endPoint = getKeyboardEndpoint(event, this.direction);
      if (endPoint === null) {
        return;
      }
      this.endPoint = endPoint;
      this.startPoint = getPointFromEvent(event);
      event.preventDefault();
      event.stopPropagation();
      this.setupForDragEvent(gutterOrder, gutterNum);
      this.startDragging();
      this.drag();
      this.stopDragging();
    }
    startMouseDrag(event, gutterOrder, gutterNum) {
      if (this.customGutter && !this.customGutter.canStartDragging(event.target, gutterNum)) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      this.startPoint = getPointFromEvent(event);
      if (this.startPoint === null || this.disabled === true || this.isWaitingClear === true) {
        return;
      }
      this.setupForDragEvent(gutterOrder, gutterNum);
      this.dragListeners.push(this.renderer.listen('document', 'mouseup', this.stopDragging.bind(this)));
      this.dragListeners.push(this.renderer.listen('document', 'touchend', this.stopDragging.bind(this)));
      this.dragListeners.push(this.renderer.listen('document', 'touchcancel', this.stopDragging.bind(this)));
      this.ngZone.runOutsideAngular(() => {
        this.dragListeners.push(this.renderer.listen('document', 'mousemove', this.mouseDragEvent.bind(this)));
        this.dragListeners.push(this.renderer.listen('document', 'touchmove', this.mouseDragEvent.bind(this)));
      });
      this.startDragging();
    }
    setupForDragEvent(gutterOrder, gutterNum) {
      this.snapshot = {
        gutterNum,
        lastSteppedOffset: 0,
        allAreasSizePixel: getElementPixelSize(this.elRef, this.direction) - this.getNbGutters() * this.gutterSize,
        allInvolvedAreasSizePercent: 100,
        areasBeforeGutter: [],
        areasAfterGutter: []
      };
      this.displayedAreas.forEach(area => {
        const areaSnapshot = {
          area,
          sizePixelAtStart: getElementPixelSize(area.component.elRef, this.direction),
          sizePercentAtStart: this.unit === 'percent' ? area.size : -1 // If pixel mode, anyway, will not be used.
        };
        if (area.order < gutterOrder) {
          if (this.restrictMove === true) {
            this.snapshot.areasBeforeGutter = [areaSnapshot];
          } else {
            this.snapshot.areasBeforeGutter.unshift(areaSnapshot);
          }
        } else if (area.order > gutterOrder) {
          if (this.restrictMove === true) {
            if (this.snapshot.areasAfterGutter.length === 0) {
              this.snapshot.areasAfterGutter = [areaSnapshot];
            }
          } else {
            this.snapshot.areasAfterGutter.push(areaSnapshot);
          }
        }
      });
      // allInvolvedAreasSizePercent is only relevant if there is restrictMove as otherwise the sum
      // is always 100.
      // Pixel mode doesn't have browser % problem which is the origin of allInvolvedAreasSizePercent.
      if (this.restrictMove && this.unit === 'percent') {
        const areaSnapshotBefore = this.snapshot.areasBeforeGutter[0];
        const areaSnapshotAfter = this.snapshot.areasAfterGutter[0];
        // We have a wildcard size area beside the dragged gutter.
        // In this case we can only calculate the size based on the move restricted areas.
        if (areaSnapshotBefore.area.size === '*' || areaSnapshotAfter.area.size === '*') {
          const notInvolvedAreasSizesPercent = this.displayedAreas.reduce((accum, area) => {
            if (areaSnapshotBefore.area !== area && areaSnapshotAfter.area !== area) {
              return accum + area.size;
            }
            return accum;
          }, 0);
          this.snapshot.allInvolvedAreasSizePercent = 100 - notInvolvedAreasSizesPercent;
        } else {
          // No wildcard or not beside the gutter - we can just sum the areas beside gutter percents.
          this.snapshot.allInvolvedAreasSizePercent = [...this.snapshot.areasBeforeGutter, ...this.snapshot.areasAfterGutter].reduce((t, a) => t + a.sizePercentAtStart, 0);
        }
      }
      if (this.snapshot.areasBeforeGutter.length === 0 || this.snapshot.areasAfterGutter.length === 0) {
        return;
      }
    }
    startDragging() {
      this.displayedAreas.forEach(area => area.component.lockEvents());
      this.isDragging = true;
      this.isWaitingInitialMove = true;
    }
    mouseDragEvent(event) {
      event.preventDefault();
      event.stopPropagation();
      const tempPoint = getPointFromEvent(event);
      if (this._clickTimeout !== null && !pointDeltaEquals(this.startPoint, tempPoint, this.gutterClickDeltaPx)) {
        window.clearTimeout(this._clickTimeout);
        this._clickTimeout = null;
      }
      if (this.isDragging === false) {
        return;
      }
      this.endPoint = getPointFromEvent(event);
      if (this.endPoint === null) {
        return;
      }
      this.drag();
    }
    drag() {
      if (this.isWaitingInitialMove) {
        if (this.startPoint.x !== this.endPoint.x || this.startPoint.y !== this.endPoint.y) {
          this.ngZone.run(() => {
            this.isWaitingInitialMove = false;
            this.renderer.addClass(this.elRef.nativeElement, 'as-dragging');
            this.draggedGutterNum = this.snapshot.gutterNum;
            this.cdRef.markForCheck();
            this.notify('start', this.snapshot.gutterNum);
          });
        } else {
          return;
        }
      }
      // Calculate steppedOffset
      let offset = this.direction === 'horizontal' ? this.startPoint.x - this.endPoint.x : this.startPoint.y - this.endPoint.y;
      // RTL requires negative offset only in horizontal mode as in vertical
      // RTL has no effect on drag direction.
      if (this.dir === 'rtl' && this.direction === 'horizontal') {
        offset = -offset;
      }
      const steppedOffset = Math.round(offset / this.gutterStep) * this.gutterStep;
      if (steppedOffset === this.snapshot.lastSteppedOffset) {
        return;
      }
      this.snapshot.lastSteppedOffset = steppedOffset;
      // Need to know if each gutter side areas could reacts to steppedOffset
      let areasBefore = getGutterSideAbsorptionCapacity(this.unit, this.snapshot.areasBeforeGutter, -steppedOffset, this.snapshot.allAreasSizePixel);
      let areasAfter = getGutterSideAbsorptionCapacity(this.unit, this.snapshot.areasAfterGutter, steppedOffset, this.snapshot.allAreasSizePixel);
      // Each gutter side areas can't absorb all offset
      if (areasBefore.remain !== 0 && areasAfter.remain !== 0) {
        // TODO: fix this emty block
        if (Math.abs(areasBefore.remain) === Math.abs(areasAfter.remain)) {
          /* empty */
        } else if (Math.abs(areasBefore.remain) > Math.abs(areasAfter.remain)) {
          areasAfter = getGutterSideAbsorptionCapacity(this.unit, this.snapshot.areasAfterGutter, steppedOffset + areasBefore.remain, this.snapshot.allAreasSizePixel);
        } else {
          areasBefore = getGutterSideAbsorptionCapacity(this.unit, this.snapshot.areasBeforeGutter, -(steppedOffset - areasAfter.remain), this.snapshot.allAreasSizePixel);
        }
      } else if (areasBefore.remain !== 0) {
        // Areas before gutter can't absorbs all offset > need to recalculate sizes for areas after gutter.
        areasAfter = getGutterSideAbsorptionCapacity(this.unit, this.snapshot.areasAfterGutter, steppedOffset + areasBefore.remain, this.snapshot.allAreasSizePixel);
      } else if (areasAfter.remain !== 0) {
        // Areas after gutter can't absorbs all offset > need to recalculate sizes for areas before gutter.
        areasBefore = getGutterSideAbsorptionCapacity(this.unit, this.snapshot.areasBeforeGutter, -(steppedOffset - areasAfter.remain), this.snapshot.allAreasSizePixel);
      }
      if (this.unit === 'percent') {
        // Hack because of browser messing up with sizes using calc(X% - Ypx) -> el.getBoundingClientRect()
        // If not there, playing with gutters makes total going down to 99.99875% then 99.99286%, 99.98986%,..
        const all = [...areasBefore.list, ...areasAfter.list];
        const wildcardArea = all.find(a => a.percentAfterAbsorption === '*');
        // In case we have a wildcard area - always align the percents on the wildcard area.
        const areaToReset = wildcardArea ?? all.find(a => a.percentAfterAbsorption !== 0 && a.percentAfterAbsorption !== a.areaSnapshot.area.minSize && a.percentAfterAbsorption !== a.areaSnapshot.area.maxSize);
        if (areaToReset) {
          areaToReset.percentAfterAbsorption = this.snapshot.allInvolvedAreasSizePercent - all.filter(a => a !== areaToReset).reduce((total, a) => total + a.percentAfterAbsorption, 0);
        }
      }
      // Now we know areas could absorb steppedOffset, time to really update sizes
      areasBefore.list.forEach(item => updateAreaSize(this.unit, item));
      areasAfter.list.forEach(item => updateAreaSize(this.unit, item));
      this.refreshStyleSizes();
      this.notify('progress', this.snapshot.gutterNum);
    }
    stopDragging(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.isDragging === false) {
        return;
      }
      this.displayedAreas.forEach(area => area.component.unlockEvents());
      while (this.dragListeners.length > 0) {
        const fct = this.dragListeners.pop();
        if (fct) {
          fct();
        }
      }
      // Warning: Have to be before "notify('end')"
      // because "notify('end')"" can be linked to "[size]='x'" > "build()" > "stopDragging()"
      this.isDragging = false;
      // If moved from starting point, notify end
      if (this.isWaitingInitialMove === false) {
        this.notify('end', this.snapshot.gutterNum);
      }
      this.renderer.removeClass(this.elRef.nativeElement, 'as-dragging');
      this.draggedGutterNum = undefined;
      this.cdRef.markForCheck();
      this.snapshot = null;
      this.isWaitingClear = true;
      // Needed to let (click)="clickGutter(...)" event run and verify if mouse moved or not
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.startPoint = null;
          this.endPoint = null;
          this.isWaitingClear = false;
        });
      });
    }
    notify(type, gutterNum) {
      const sizes = this.getVisibleAreaSizes();
      if (type === 'start') {
        this.dragStart.emit({
          gutterNum,
          sizes
        });
      } else if (type === 'end') {
        this.dragEnd.emit({
          gutterNum,
          sizes
        });
      } else if (type === 'click') {
        this.gutterClick.emit({
          gutterNum,
          sizes
        });
      } else if (type === 'dblclick') {
        this.gutterDblClick.emit({
          gutterNum,
          sizes
        });
      } else if (type === 'transitionEnd') {
        if (this.transitionEndSubscriber) {
          this.ngZone.run(() => this.transitionEndSubscriber.next(sizes));
        }
      } else if (type === 'progress') {
        // Stay outside zone to allow users do what they want about change detection mechanism.
        this.dragProgressSubject.next({
          gutterNum,
          sizes
        });
      }
    }
    ngOnDestroy() {
      this.stopDragging();
    }
    collapseArea(comp, newSize, gutter) {
      const area = this.displayedAreas.find(a => a.component === comp);
      if (area === undefined) {
        return;
      }
      const whichGutter = gutter === 'right' ? 1 : -1;
      if (!area.sizeBeforeCollapse) {
        area.sizeBeforeCollapse = area.size;
        area.gutterBeforeCollapse = whichGutter;
      }
      area.size = newSize;
      const gtr = this.gutterEls.find(f => f.nativeElement.style.order === `${area.order + whichGutter}`);
      if (gtr) {
        this.renderer.addClass(gtr.nativeElement, 'as-split-gutter-collapsed');
      }
      this.updateArea(comp, false, false);
    }
    expandArea(comp) {
      const area = this.displayedAreas.find(a => a.component === comp);
      if (area === undefined) {
        return;
      }
      if (!area.sizeBeforeCollapse) {
        return;
      }
      area.size = area.sizeBeforeCollapse;
      area.sizeBeforeCollapse = null;
      const gtr = this.gutterEls.find(f => f.nativeElement.style.order === `${area.order + area.gutterBeforeCollapse}`);
      if (gtr) {
        this.renderer.removeClass(gtr.nativeElement, 'as-split-gutter-collapsed');
      }
      this.updateArea(comp, false, false);
    }
    getAriaAreaSizeText(size) {
      if (size === '*') {
        return null;
      }
      return size.toFixed(0) + ' ' + this.unit;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function SplitComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(ANGULAR_SPLIT_DEFAULT_OPTIONS, 8));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SplitComponent,
        selectors: [["as-split"]],
        contentQueries: function SplitComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SplitGutterDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customGutter = _t.first);
          }
        },
        viewQuery: function SplitComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.gutterEls = _t);
          }
        },
        inputs: {
          direction: "direction",
          unit: "unit",
          gutterSize: "gutterSize",
          gutterStep: "gutterStep",
          restrictMove: "restrictMove",
          useTransition: "useTransition",
          disabled: "disabled",
          dir: "dir",
          gutterDblClickDuration: "gutterDblClickDuration",
          gutterClickDeltaPx: "gutterClickDeltaPx",
          gutterAriaLabel: "gutterAriaLabel"
        },
        outputs: {
          transitionEnd: "transitionEnd",
          dragStart: "dragStart",
          dragEnd: "dragEnd",
          gutterClick: "gutterClick",
          gutterDblClick: "gutterDblClick"
        },
        exportAs: ["asSplit"],
        ngContentSelectors: _c1,
        decls: 2,
        vars: 1,
        consts: [["gutterEls", ""], ["defaultGutterTpl", ""], ["ngFor", "", 3, "ngForOf"], ["role", "separator", "tabindex", "0", "class", "as-split-gutter", 3, "as-dragged", "flex-basis", "order", "keydown", "mousedown", "touchstart", "mouseup", "touchend", 4, "ngIf"], ["role", "separator", "tabindex", "0", 1, "as-split-gutter", 3, "keydown", "mousedown", "touchstart", "mouseup", "touchend"], [4, "ngIf", "ngIfElse"], [4, "asSplitGutterDynamicInjector"], [4, "ngTemplateOutlet", "ngTemplateOutletContext", "ngTemplateOutletInjector"], [1, "as-split-gutter-icon"]],
        template: function SplitComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, SplitComponent_ng_template_1_Template, 1, 1, "ng-template", 2);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.displayedAreas);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, SplitGutterDynamicInjectorDirective],
        styles: ["[_nghost-%COMP%]{display:flex;flex-wrap:nowrap;justify-content:flex-start;align-items:stretch;overflow:hidden;width:100%;height:100%}[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%]{border:none;flex-grow:0;flex-shrink:0;background-color:#eee;display:flex;align-items:center;justify-content:center}[_nghost-%COMP%] > .as-split-gutter.as-split-gutter-collapsed[_ngcontent-%COMP%]{flex-basis:1px!important;pointer-events:none}[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%] > .as-split-gutter-icon[_ngcontent-%COMP%]{width:100%;height:100%;background-position:center center;background-repeat:no-repeat}[_nghost-%COMP%]    >.as-split-area{flex-grow:0;flex-shrink:0;overflow-x:hidden;overflow-y:auto}[_nghost-%COMP%]    >.as-split-area.as-hidden{flex:0 1 0px!important;overflow-x:hidden;overflow-y:hidden}[_nghost-%COMP%]    >.as-split-area .iframe-fix{position:absolute;top:0;left:0;width:100%;height:100%}.as-horizontal[_nghost-%COMP%]{flex-direction:row}.as-horizontal[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%]{flex-direction:row;cursor:col-resize;height:100%}.as-horizontal[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%] > .as-split-gutter-icon[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==)}.as-horizontal[_nghost-%COMP%]    >.as-split-area{height:100%}.as-vertical[_nghost-%COMP%]{flex-direction:column}.as-vertical[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%]{flex-direction:column;cursor:row-resize;width:100%}.as-vertical[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%]   .as-split-gutter-icon[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFCAMAAABl/6zIAAAABlBMVEUAAADMzMzIT8AyAAAAAXRSTlMAQObYZgAAABRJREFUeAFjYGRkwIMJSeMHlBkOABP7AEGzSuPKAAAAAElFTkSuQmCC)}.as-vertical[_nghost-%COMP%]    >.as-split-area{width:100%}.as-vertical[_nghost-%COMP%]    >.as-split-area.as-hidden{max-width:0}.as-disabled[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%]{cursor:default}.as-disabled[_nghost-%COMP%] > .as-split-gutter[_ngcontent-%COMP%]   .as-split-gutter-icon[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==)}.as-transition.as-init[_nghost-%COMP%]:not(.as-dragging) > .as-split-gutter[_ngcontent-%COMP%], .as-transition.as-init[_nghost-%COMP%]:not(.as-dragging)    >.as-split-area{transition:flex-basis .3s}"],
        changeDetection: 0
      });
    }
  }
  return SplitComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SplitAreaDirective = /*#__PURE__*/(() => {
  class SplitAreaDirective {
    set order(v) {
      this._order = getInputPositiveNumber(v, null);
      this.split.updateArea(this, true, false);
    }
    get order() {
      return this._order;
    }
    set size(v) {
      this._size = getInputPositiveNumber(v, '*');
      this.split.updateArea(this, false, true);
    }
    get size() {
      return this._size;
    }
    set minSize(v) {
      this._minSize = getInputPositiveNumber(v, null);
      this.split.updateArea(this, false, true);
    }
    get minSize() {
      return this._minSize;
    }
    set maxSize(v) {
      this._maxSize = getInputPositiveNumber(v, null);
      this.split.updateArea(this, false, true);
    }
    get maxSize() {
      return this._maxSize;
    }
    set lockSize(v) {
      this._lockSize = getInputBoolean(v);
      this.split.updateArea(this, false, true);
    }
    get lockSize() {
      return this._lockSize;
    }
    set visible(v) {
      this._visible = getInputBoolean(v);
      if (this._visible) {
        this.split.showArea(this);
        this.renderer.removeClass(this.elRef.nativeElement, 'as-hidden');
      } else {
        this.split.hideArea(this);
        this.renderer.addClass(this.elRef.nativeElement, 'as-hidden');
      }
    }
    get visible() {
      return this._visible;
    }
    constructor(ngZone, renderer, split, elRef) {
      this.ngZone = ngZone;
      this.renderer = renderer;
      this.split = split;
      this.elRef = elRef;
      this._order = null;
      this._size = '*';
      this._minSize = null;
      this._maxSize = null;
      this._lockSize = false;
      this._visible = true;
      this.lockListeners = [];
      this.renderer.addClass(this.elRef.nativeElement, 'as-split-area');
    }
    ngOnInit() {
      this.split.addArea(this);
      this.ngZone.runOutsideAngular(() => {
        this.transitionListener = this.renderer.listen(this.elRef.nativeElement, 'transitionend', event => {
          // Limit only flex-basis transition to trigger the event
          if (event.propertyName === 'flex-basis') {
            this.split.notify('transitionEnd', -1);
          }
        });
      });
      const iframeFixDiv = this.renderer.createElement('div');
      this.renderer.addClass(iframeFixDiv, 'iframe-fix');
      this.dragStartSubscription = this.split.dragStart.subscribe(() => {
        this.renderer.setStyle(this.elRef.nativeElement, 'position', 'relative');
        this.renderer.appendChild(this.elRef.nativeElement, iframeFixDiv);
      });
      this.dragEndSubscription = this.split.dragEnd.subscribe(() => {
        this.renderer.removeStyle(this.elRef.nativeElement, 'position');
        this.renderer.removeChild(this.elRef.nativeElement, iframeFixDiv);
      });
    }
    setStyleOrder(value) {
      this.renderer.setStyle(this.elRef.nativeElement, 'order', value);
    }
    setStyleFlex(grow, shrink, basis, isMin, isMax) {
      // Need 3 separated properties to work on IE11 (https://github.com/angular/flex-layout/issues/323)
      this.renderer.setStyle(this.elRef.nativeElement, 'flex-grow', grow);
      this.renderer.setStyle(this.elRef.nativeElement, 'flex-shrink', shrink);
      this.renderer.setStyle(this.elRef.nativeElement, 'flex-basis', basis);
      if (isMin === true) {
        this.renderer.addClass(this.elRef.nativeElement, 'as-min');
      } else {
        this.renderer.removeClass(this.elRef.nativeElement, 'as-min');
      }
      if (isMax === true) {
        this.renderer.addClass(this.elRef.nativeElement, 'as-max');
      } else {
        this.renderer.removeClass(this.elRef.nativeElement, 'as-max');
      }
    }
    lockEvents() {
      this.ngZone.runOutsideAngular(() => {
        this.lockListeners.push(this.renderer.listen(this.elRef.nativeElement, 'selectstart', () => false));
        this.lockListeners.push(this.renderer.listen(this.elRef.nativeElement, 'dragstart', () => false));
      });
    }
    unlockEvents() {
      while (this.lockListeners.length > 0) {
        const fct = this.lockListeners.pop();
        if (fct) {
          fct();
        }
      }
    }
    ngOnDestroy() {
      this.unlockEvents();
      if (this.transitionListener) {
        this.transitionListener();
      }
      this.dragStartSubscription?.unsubscribe();
      this.dragEndSubscription?.unsubscribe();
      this.split.removeArea(this);
    }
    collapse(newSize = 0, gutter = 'right') {
      this.split.collapseArea(this, newSize, gutter);
    }
    expand() {
      this.split.expandArea(this);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function SplitAreaDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitAreaDirective)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(SplitComponent), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SplitAreaDirective,
        selectors: [["as-split-area"], ["", "as-split-area", ""]],
        inputs: {
          order: "order",
          size: "size",
          minSize: "minSize",
          maxSize: "maxSize",
          lockSize: "lockSize",
          visible: "visible"
        },
        exportAs: ["asSplitArea"]
      });
    }
  }
  return SplitAreaDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SplitGutterDragHandleDirective = /*#__PURE__*/(() => {
  class SplitGutterDragHandleDirective {
    constructor(gutterNum, elementRef, gutterDir) {
      this.gutterNum = gutterNum;
      this.elementRef = elementRef;
      this.gutterDir = gutterDir;
    }
    ngOnInit() {
      this.gutterDir.addToMap(this.gutterDir.gutterToHandleElementMap, this.gutterNum, this.elementRef);
    }
    ngOnDestroy() {
      this.gutterDir.removedFromMap(this.gutterDir.gutterToHandleElementMap, this.gutterNum, this.elementRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function SplitGutterDragHandleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitGutterDragHandleDirective)(i0.ɵɵdirectiveInject(GUTTER_NUM_TOKEN), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SplitGutterDirective));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SplitGutterDragHandleDirective,
        selectors: [["", "asSplitGutterDragHandle", ""]]
      });
    }
  }
  return SplitGutterDragHandleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SplitGutterExcludeFromDragDirective = /*#__PURE__*/(() => {
  class SplitGutterExcludeFromDragDirective {
    constructor(gutterNum, elementRef, gutterDir) {
      this.gutterNum = gutterNum;
      this.elementRef = elementRef;
      this.gutterDir = gutterDir;
    }
    ngOnInit() {
      this.gutterDir.addToMap(this.gutterDir.gutterToExcludeDragElementMap, this.gutterNum, this.elementRef);
    }
    ngOnDestroy() {
      this.gutterDir.removedFromMap(this.gutterDir.gutterToExcludeDragElementMap, this.gutterNum, this.elementRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function SplitGutterExcludeFromDragDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitGutterExcludeFromDragDirective)(i0.ɵɵdirectiveInject(GUTTER_NUM_TOKEN), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SplitGutterDirective));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SplitGutterExcludeFromDragDirective,
        selectors: [["", "asSplitGutterExcludeFromDrag", ""]]
      });
    }
  }
  return SplitGutterExcludeFromDragDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AngularSplitModule = /*#__PURE__*/(() => {
  class AngularSplitModule {
    /** @nocollapse */static {
      this.ɵfac = function AngularSplitModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AngularSplitModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AngularSplitModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return AngularSplitModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of angular-split
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ANGULAR_SPLIT_DEFAULT_OPTIONS, AngularSplitModule, SplitAreaDirective, SplitComponent, SplitGutterDirective, SplitGutterDragHandleDirective, SplitGutterExcludeFromDragDirective };
